export default __webpack_public_path__ + "static/media/noScheduleTransaction.659802f3.svg";